<div class="mat-dialog-container">
  <!-- 明細編輯開始 -->
  <div #head>
    <app-modal-header #modal_header [isDialog]="isDialog" [title]="title" [state]="srv.state" (onOkClick)="doOk($event)"
      (onEditAndSaveClick)="doEditAndSave($event)"
      (onCancelClick)="doCancel($event)">
    </app-modal-header>
  </div>
  <div class="jk-content">
    <div class="jk-grid-cols-4"> 
    <app-jkedit  label="發票退回原因" #WC068Com  id="WC068"  [(value)]="item.WC068" placeholder="發票退回原因"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jknumberedit  label="營業稅額" #WC063Com  id="WC063"  [(value)]="item.WC063" placeholder="營業稅額"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jknumberedit  label="總計" #WC064Com  id="WC064"  [(value)]="item.WC064" placeholder="總計"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jkedit  label="折讓種類列表" #WC065Com  id="WC065"  [(value)]="item.WC065" placeholder="折讓種類列表"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="彙開註記" #WC066Com  id="WC066"  [(value)]="item.WC066" placeholder="彙開註記"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="批次號" #WC067Com  id="WC067"  [(value)]="item.WC067" placeholder="批次號"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jknumberedit  label="零稅率銷售額合計" #WC062Com  id="WC062"  [(value)]="item.WC062" placeholder="零稅率銷售額合計"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jknumberedit  label="預留欄位" #WC069Com  id="WC069"  [(value)]="item.WC069" placeholder="預留欄位"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jkedit  label="發票起始碼" #WC070Com  id="WC070"  [(value)]="item.WC070" placeholder="發票起始碼"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="發票訖號" #WC071Com  id="WC071"  [(value)]="item.WC071" placeholder="發票訖號"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="預留欄位" #WC072Com  id="WC072"  [(value)]="item.WC072" placeholder="預留欄位"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="預留欄位" #WC073Com  id="WC073"  [(value)]="item.WC073" placeholder="預留欄位"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkdatefield  label="檢核日期" #WC074Com  id="WC074"  [(value)]="item.WC074" placeholder="檢核日期"  [readonly]="isBrowse" 
            >
    </app-jkdatefield>
    <app-jkcheckboxYN  label="更新碼" #WC055Com  id="WC055"  [(valueYN)]="item.WC055"  [readonly]="isBrowse"     >
    </app-jkcheckboxYN>
    <app-jkedit  label="相關號碼" #WC051Com  id="WC051"  [(value)]="item.WC051" placeholder="相關號碼"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jktextarea  height="250px" 
 label="總備註" #WC052Com  id="WC052"  [(value)]="item.WC052" placeholder="總備註"  [readonly]="isBrowse"     >
    </app-jktextarea>
    <app-jktextarea  height="250px" 
 label="備註" #WC053Com  id="WC053"  [(value)]="item.WC053" placeholder="備註"  [readonly]="isBrowse"     >
    </app-jktextarea>
    <app-jkedit  label="買受人簽署適用零稅率" #WC054Com  id="WC054"  [(value)]="item.WC054" placeholder="買受人簽署適用零稅率"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jknumberedit  label="免稅銷售額合計" #WC061Com  id="WC061"  [(value)]="item.WC061" placeholder="免稅銷售額合計"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jkedit  label="執行結果" #WC056Com  id="WC056"  [(value)]="item.WC056" placeholder="執行結果"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="來源碼" #WC057Com  id="WC057"  [(value)]="item.WC057" placeholder="來源碼"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jktext  label="開立時間" [value]="item.WC058"     >
    </app-jktext>
    <app-jkedit  label="折讓種類" #WC059Com  id="WC059"  [(value)]="item.WC059" placeholder="折讓種類"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jknumberedit  label="應稅銷售額合計" #WC060Com  id="WC060"  [(value)]="item.WC060" placeholder="應稅銷售額合計"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jkedit  label="沖帳別" #WC050Com  id="WC050"  [(value)]="item.WC050" placeholder="沖帳別"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="預留欄位" #WC092Com  id="WC092"  [(value)]="item.WC092" placeholder="預留欄位"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="預留欄位" #WC088Com  id="WC088"  [(value)]="item.WC088" placeholder="預留欄位"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jknumberedit  label="預留欄位" #WC089Com  id="WC089"  [(value)]="item.WC089" placeholder="預留欄位"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jkedit  label="傳送或接收" #WC090Com  id="WC090"  [(value)]="item.WC090" [required]="true"  placeholder="傳送或接收"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="預留欄位" #WC091Com  id="WC091"  [(value)]="item.WC091" placeholder="預留欄位"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="預留欄位" #WC087Com  id="WC087"  [(value)]="item.WC087" placeholder="預留欄位"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="預留欄位" #WC093Com  id="WC093"  [(value)]="item.WC093" placeholder="預留欄位"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="預留欄位" #WC094Com  id="WC094"  [(value)]="item.WC094" placeholder="預留欄位"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="預留欄位" #WC095Com  id="WC095"  [(value)]="item.WC095" placeholder="預留欄位"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="INVOICE_IDENTIFIER" #WC096Com  id="WC096"  [(value)]="item.WC096" placeholder="INVOICE_IDENTIFIER"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="預留欄位" #WC097Com  id="WC097"  [(value)]="item.WC097" placeholder="預留欄位"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="預留欄位" #WC075Com  id="WC075"  [(value)]="item.WC075" placeholder="預留欄位"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="預留欄位" #WC080Com  id="WC080"  [(value)]="item.WC080" placeholder="預留欄位"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="預留欄位" #WC076Com  id="WC076"  [(value)]="item.WC076" placeholder="預留欄位"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="發票字軌" #WC077Com  id="WC077"  [(value)]="item.WC077" placeholder="發票字軌"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="預留欄位" #WC078Com  id="WC078"  [(value)]="item.WC078" placeholder="預留欄位"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="預留欄位" #WC079Com  id="WC079"  [(value)]="item.WC079" placeholder="預留欄位"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="預留欄位" #WC086Com  id="WC086"  [(value)]="item.WC086" placeholder="預留欄位"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jknumberedit  label="預留欄位" #WC081Com  id="WC081"  [(value)]="item.WC081" placeholder="預留欄位"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jknumberedit  label="預留欄位" #WC082Com  id="WC082"  [(value)]="item.WC082" placeholder="預留欄位"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jkcheckboxYN  label="A0101接收確認" #WC083Com  id="WC083"  [(valueYN)]="item.WC083"  [readonly]="isBrowse"     >
    </app-jkcheckboxYN>
    <app-jkedit  label="TURNKEY狀態" #WC084Com  id="WC084"  [(value)]="item.WC084" placeholder="TURNKEY狀態"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkcheckboxYN  label="A0102確認上傳碼" #WC085Com  id="WC085"  [(valueYN)]="item.WC085"  [readonly]="isBrowse"     >
    </app-jkcheckboxYN>
    <app-jkedit  label="發票號碼" #WC001Com  id="WC001"  [(value)]="item.WC001" [required]="true"  placeholder="發票號碼"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="賣方電話" #WC019Com  id="WC019"  [(value)]="item.WC019" placeholder="賣方電話"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkcheckboxYN  label="紙本電子發票列印註記" #WC014Com  id="WC014"  [(valueYN)]="item.WC014"  [readonly]="isBrowse"     >
    </app-jkcheckboxYN>
    <app-jkedit  label="買受人註記欄" #WC015Com  id="WC015"  [(value)]="item.WC015" placeholder="買受人註記欄"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="賣方名稱" #WC016Com  id="WC016"  [(value)]="item.WC016" placeholder="賣方名稱"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="賣方地址" #WC017Com  id="WC017"  [(value)]="item.WC017" placeholder="賣方地址"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="賣方負責人姓名" #WC018Com  id="WC018"  [(value)]="item.WC018" placeholder="賣方負責人姓名"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="載具隱碼id" #WC013Com  id="WC013"  [(value)]="item.WC013" placeholder="載具隱碼id"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="賣方傳真" #WC020Com  id="WC020"  [(value)]="item.WC020" placeholder="賣方傳真"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="賣方電子郵件地址" #WC021Com  id="WC021"  [(value)]="item.WC021" placeholder="賣方電子郵件地址"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="買方名稱" #WC022Com  id="WC022"  [(value)]="item.WC022" placeholder="買方名稱"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="買方地址" #WC023Com  id="WC023"  [(value)]="item.WC023" placeholder="買方地址"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="買方負責人姓名" #WC024Com  id="WC024"  [(value)]="item.WC024" placeholder="買方負責人姓名"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="買方電話號碼" #WC025Com  id="WC025"  [(value)]="item.WC025" placeholder="買方電話號碼"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="賣方統一編號" #WC006Com  id="WC006"  [(value)]="item.WC006" placeholder="賣方統一編號"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="訊息類別" #WC002Com  id="WC002"  [(value)]="item.WC002" [required]="true"  placeholder="訊息類別"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jktext  label="申報年月" [value]="item.WC003"     >
    </app-jktext>
    <app-jkdatefield  label="開立日期" #WC004Com  id="WC004"  [(value)]="item.WC004" placeholder="開立日期"  [readonly]="isBrowse" 
            >
    </app-jkdatefield>
    <app-jkedit  label="買方統一編號" #WC005Com  id="WC005"  [(value)]="item.WC005" placeholder="買方統一編號"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="載具顯碼id" #WC012Com  id="WC012"  [(value)]="item.WC012" placeholder="載具顯碼id"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="課稅別" #WC007Com  id="WC007"  [(value)]="item.WC007" placeholder="課稅別"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="來源方式" #WC008Com  id="WC008"  [(value)]="item.WC008" placeholder="來源方式"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkbtnedit  maintable="CMSMQ" item="W01" valueExpr="MQ001" displayExpr="MQ00" 
 label="來源單別" #WC009Com  id="WC009"  [(value)]="item.WC009" placeholder="來源單別"  [readonly]="isBrowse"     >
    </app-jkbtnedit>
    <app-jktext  label="來源單號" [value]="item.WC010"     >
    </app-jktext>
    <app-jkedit  label="載具類別號碼" #WC011Com  id="WC011"  [(value)]="item.WC011" placeholder="載具類別號碼"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="買方營業人角色註記" #WC049Com  id="WC049"  [(value)]="item.WC049" placeholder="買方營業人角色註記"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="專案作廢核准文號" #WC043Com  id="WC043"  [(value)]="item.WC043" placeholder="專案作廢核准文號"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkdatefield  label="發票作廢日期" #WC039Com  id="WC039"  [(value)]="item.WC039" placeholder="發票作廢日期"  [readonly]="isBrowse" 
            >
    </app-jkdatefield>
    <app-jktext  label="發票作廢時間" [value]="item.WC040"     >
    </app-jktext>
    <app-jkcheckboxYN  label="發票作廢碼" #WC041Com  id="WC041"  [(valueYN)]="item.WC041"  [readonly]="isBrowse"     >
    </app-jkcheckboxYN>
    <app-jkcheckboxYN  label="發票作廢上傳碼" #WC042Com  id="WC042"  [(valueYN)]="item.WC042"  [readonly]="isBrowse"     >
    </app-jkcheckboxYN>
    <app-jkcheckboxYN  label="發票開立上傳碼" #WC038Com  id="WC038"  [(valueYN)]="item.WC038"  [readonly]="isBrowse"     >
    </app-jkcheckboxYN>
    <app-jkedit  label="發票作廢原因" #WC044Com  id="WC044"  [(value)]="item.WC044" placeholder="發票作廢原因"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkdatefield  label="接收(退回)日期" #WC045Com  id="WC045"  [(value)]="item.WC045" placeholder="接收(退回)日期"  [readonly]="isBrowse" 
            >
    </app-jkdatefield>
    <app-jktext  label="接收(退回)時間" [value]="item.WC046"     >
    </app-jktext>
    <app-jkedit  label="狀態碼" #WC047Com  id="WC047"  [(value)]="item.WC047" placeholder="狀態碼"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="賣方營業人角色註記" #WC048Com  id="WC048"  [(value)]="item.WC048" placeholder="賣方營業人角色註記"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="買方傳真號碼" #WC026Com  id="WC026"  [(value)]="item.WC026" placeholder="買方傳真號碼"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="捐贈註記" #WC031Com  id="WC031"  [(value)]="item.WC031" placeholder="捐贈註記"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="買方電子郵件" #WC027Com  id="WC027"  [(value)]="item.WC027" placeholder="買方電子郵件"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="發票檢查碼" #WC028Com  id="WC028"  [(value)]="item.WC028" placeholder="發票檢查碼"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="捐贈對象" #WC029Com  id="WC029"  [(value)]="item.WC029" placeholder="捐贈對象"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="發票類別" #WC030Com  id="WC030"  [(value)]="item.WC030" placeholder="發票類別"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="發票防偽隨機碼" #WC037Com  id="WC037"  [(value)]="item.WC037" placeholder="發票防偽隨機碼"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jknumberedit  label="稅率" #WC032Com  id="WC032"  [(value)]="item.WC032" placeholder="稅率"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jknumberedit  label="扣抵金額" #WC033Com  id="WC033"  [(value)]="item.WC033" placeholder="扣抵金額"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jknumberedit  label="原幣金額" #WC034Com  id="WC034"  [(value)]="item.WC034" placeholder="原幣金額"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jknumberedit  label="匯率" #WC035Com  id="WC035"  [(value)]="item.WC035" placeholder="匯率"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jkedit  label="幣別" #WC036Com  id="WC036"  [(value)]="item.WC036" placeholder="幣別"  [readonly]="isBrowse"     >
    </app-jkedit>

    </div>
  </div>
</div>